<template>
  <div>
    <a-drawer :title="getTitle" :width="960" :visible="visible" :mask-closable="false" :ok-button-props="{ props: { loading: loading } }" @close="closed" @ok="onSubmit">
      <a-spin :spinning="spinning">
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item label="标题" prop="title">
                <a-input v-model="form.title" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="描述内容" prop="description">
                <vditor-editor v-model="form.description" :height="300" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="优先级" prop="priority">
                <a-select v-model="form.priority" allow-clear placeholder="优先级">
                  <a-select-option v-for="(item, index) in issuePrioritys" :key="index" :value="item.value">
                    <a-tag :color="item.color"> {{ item.label }} </a-tag>
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="缺陷类型" prop="issue_type">
                <a-select v-model="form.issue_type" allow-clear placeholder="缺陷类型">
                  <a-select-option v-for="(item, index) in issueTypes" :key="index" :value="item.value">
                    <a-badge :status="item.status" :color="item.color" :text="item.label" />
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="缺陷级别" prop="serious">
                <a-select v-model="form.serious" allow-clear placeholder="缺陷级别">
                  <a-select-option v-for="(item, key) in issueSerious" :key="key" :value="item.value">{{ item.label }} </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="出现频率" prop="chance">
                <a-select v-model="form.chance" allow-clear placeholder="出现频率">
                  <a-select-option v-for="(item, key) in issueChances" :key="key" :value="item.value">{{ item.label }} </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="验证人" prop="verifier">
                <a-select v-model="form.verifier" allow-clear placeholder="验证人" show-search :filter-option="utils.filterOption">
                  <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="处理人" prop="handler">
                <a-select v-model="form.handler" allow-clear placeholder="处理人" show-search :filter-option="utils.filterOption">
                  <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="系统/平台" prop="system">
                <a-select v-model="form.system" allow-clear placeholder="系统/平台" @change="getApplicationTreeVersions">
                  <a-select-option value="Android">Android</a-select-option>
                  <a-select-option value="iOS">iOS</a-select-option>
                  <a-select-option value="小程序">小程序</a-select-option>
                  <a-select-option value="H5">H5</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="系统/平台版本" prop="system_version">
                <a-tree-select v-model="form.system_version" :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }" placeholder="系统/平台版本" :tree-data="systemVersionData" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="关联需求" prop="requirement">
                <a-select v-model="requirementValue" show-search label-in-value style="width: 100%" :filter-option="false" :not-found-content="storySearching ? undefined : null" @search="searchStory" @change="handleStoryChange">
                  <a-spin v-if="storySearching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="item in searchStoryData" :key="item.value" :value="item.value" :version="item.version">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="关联迭代" prop="version_id">
                <a-select v-model="versionValue" show-search label-in-value style="width: 100%" :filter-option="false" :not-found-content="versionSearching ? undefined : null" @search="searchVersion" @change="handleVersionChange">
                  <a-spin v-if="versionSearching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="item in searchVersionData" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </a-drawer>
  </div>
</template>
<script>
import { issueDetail, issueAdd, issueUpdate } from '@/api/project/issue';
import { applicationTreeVersions } from '@/api/tools/application';
import { storySearch } from '@/api/project/story';
import { versionSearch } from '@/api/project/version';
import { issueStatus, issueTypes, issuePrioritys, issueSerious, issueChances } from '@/utils/dictionary';
import VditorEditor from '@/components/VditorEditor';
import { userList } from '@/api/system/auth';

export default {
  components: { VditorEditor },
  props: {
    issueId: {
      type: [Number, String],
      default: null
    },
    copyIssueId: {
      type: [Number, String],
      default: null
    },
    isShow: {
      type: Boolean,
      default: false
    },
    planId: {
      type: [Number, String],
      default: null
    },
    caseId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      issueTypes,
      issueStatus,
      issueSerious,
      issueChances,
      issuePrioritys,
      spinning: false,
      loading: false,
      visible: false,
      projects: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      requirementValue: {},
      searchStoryData: [],
      storySearching: false,
      versionValue: {},
      searchVersionData: [],
      versionSearching: false,
      form: {
        title: null,
        description: '',
        system: null,
        serious: null,
        chance: null,
        detection_chance: null,
        version: null,
        issue_type: null,
        priority: null,
        stage: null,
        relate_case: null,
        handler: null,
        comment: null,
        requirement_id: null,
        module_id: null
      },
      userData: [],
      systemVersionData: [],
      rules: {
        title: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        description: [{ required: true, message: '描述内容不能为空', trigger: 'blur' }],
        priority: [{ required: true, message: '优先级不能为空', trigger: 'blur' }],
        serious: [{ required: true, message: '缺陷级别不能为空', trigger: 'blur' }],
        issue_type: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
        chance: [{ required: true, message: '出现频率不能为空', trigger: 'blur' }],
        verifier: [{ required: true, message: '验证人不能为空', trigger: 'blur' }],
        handler: [{ required: true, message: '处理人不能为空', trigger: 'blur' }],
        requirement_id: [{ required: true, message: '关联需求不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    getTitle() {
      if (this.issueId !== null) {
        return '编辑缺陷';
      } else if (this.copyIssueId !== null) {
        return '复制缺陷';
      } else {
        return '添加缺陷';
      }
    }
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        this.versionValue = {};
        this.requirementValue = {};
        if (this.issueId !== null) {
          this.getIssueDetail(this.issueId);
        } else if (this.copyIssueId !== null) {
          this.getIssueDetail(this.copyIssueId);
        } else {
          this.form.verifier = JSON.parse(window.localStorage.getItem('user_info')).id;
          this.form.description = '**操作步骤:**\n\nxx\n\n**实际结果:**\n\nxx\n\n**预期结果:**\nxx';
        }
        this.getUserList();
      }
    }
  },
  methods: {
    closed() {
      this.visible = false;
      this.loading = false;
      this.form = {};
      this.$emit('close');
    },

    // 获取用户列表
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users;
      });
    },

    // 获取系统/平台版本
    getApplicationTreeVersions() {
      if (this.form.system !== null) {
        applicationTreeVersions({ platform: this.form.system }).then(res => {
          this.systemVersionData = res.data.items;
        });
      } else {
        this.systemVersionData = [];
      }
    },

    // 需求搜索
    searchStory(value) {
      storySearch({ project_id: this.projectId, value: value }).then(res => {
        this.searchStoryData = res.data.items;
      });
    },

    // 版本搜索
    searchVersion(value) {
      versionSearch({ project_id: this.projectId, value: value }).then(res => {
        this.searchVersionData = res.data.items;
      });
    },

    // 获取缺陷详情
    getIssueDetail(issueId) {
      this.spinning = true;
      issueDetail({ issue_id: `${issueId}`, project_id: this.projectId }).then(res => {
        const data = res.data;
        this.form = {
          ...this.form,
          system: data.system,
          system_version: data.system_version,
          title: data.title,
          description: data.description,
          status: data.status,
          priority: data.priority,
          issue_type: data.issue_type,
          serious: data.serious,
          chance: data.chance,
          handler: data.handler ? data.handler.id : null,
          verifier: data.verifier ? data.verifier.id : null
        };
        if (data.requirement) {
          this.form.requirement_id = data.requirement.id;
          this.requirementValue = { key: data.requirement.id, label: data.requirement.title };
        }
        if (data.version) {
          this.form.version_id = data.version.id;
          this.versionValue = { key: data.version.id, label: data.version.title };
        }
        if (issueId === this.copyIssueId) {
          this.form.title += ' Copy';
        }
        this.getApplicationTreeVersions();
        this.spinning = false;
      });
    },

    // 点击提交
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.issueId === null) {
            // 添加缺陷
            issueAdd({ project_id: this.projectId, plan_id: this.planId, case_id: this.caseId, ...this.form })
              .then(() => {
                this.closed();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            // 编辑缺陷
            issueUpdate({ issue_id: this.issueId, project_id: this.projectId, ...this.form })
              .then(() => {
                this.closed();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },

    handleStoryChange(value, option) {
      this.form.requirement_id = value.key;
      const version = option.data.attrs.version;
      if (version) {
        this.form.version_id = version.value;
        this.versionValue = { key: version.value, label: version.label };
      }
    },

    handleVersionChange(value) {
      this.form.version_id = value.key;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-form-item {
  margin-bottom: 4px;
}
/deep/.ant-form-item-label {
  line-height: 32px;
}
.submit {
  width: 100px;
  margin: 0 auto;
}
/deep/.ant-modal-body {
  padding: 8px 48px 16px 48px;
}
</style>
